import { nameFromUser, tenantFromUser } from './user';

export const LD_FLAG_NEW_FEATURE = 'new-admin-features-enabled';
export const LD_FLAG_USERS_AND_PERMISSIONS = 'users-and-permissions';
export const LD_FLAG_BLOCKS = 'block-management';
export const LD_FLAG_MENU_EDITOR = 'element-menus';
export const LD_FLAG_CUSTOM_FIELDS = 'product-custom-fields';
export const LD_FLAG_SITE_TAGGING = 'site-tagging-page';
export const LD_FLAG_USE_LIVE_AGENT_CHAT = 'use-live-agent-chat';
export const LD_FLAG_ELEMENT_MYVOLUSION_LAUNCH_DATE =
  'element-myvolusion-launch-date';

export const fetchFlags = async (ldClient, user) => {
  const tenantId = tenantFromUser(user);
  const name = nameFromUser(user);
  if (ldClient && ldClient.identify && user && tenantId) {
    return ldClient.identify({
      key: tenantId,
      email: user.email,
      name: `${name.firstName} ${name.lastName}`,
    });
  }
  return {};
};

export const handleLaunchDarklyRedirect = async (
  ldClient,
  user,
  router,
  featureFlag
) => {
  const result = await fetchFlags(ldClient, user);

  if (result !== undefined && result[LD_FLAG_NEW_FEATURE] !== undefined) {
    const newFeatures = {};
    result[LD_FLAG_NEW_FEATURE].forEach((f) => {
      newFeatures[f] = true;
    });
    if (!newFeatures[featureFlag]) {
      router.replace('/admin');
    }
  }
};
